import {
  partyLookup,
  usStates,
  countries
} from './options';

const parties = {
  SE: 'Selling Party',
  BY: 'Buying Party',
  CN: 'Consignee Party',
  ST: 'Shipping to Party',
  LG: 'Stuffing Location',
  CS: 'Consolidator',
};

const party = [
  {
    name: 'partyLookup',
    label: 'Party Lookup',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: true,
  },
  {
    type: 'new',
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: 'DESONICON INC',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'partyIdentifier',
    label: 'Party Identifier Number',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'duns',
    label: 'DUNS / DUNS+4',
    type: 'text',
    maxLength: 20,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    type: 'new',
  },
  {
    name: 'address1',
    label: 'Address Line 1',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: '5900 BALCONES DR',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'address2',
    label: 'Address Line 2',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: 'STE 100',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    type: 'new',
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: 'AUSTIN',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'stateProvince',
    label: 'State / Province',
    type: 'auto',
    maxLength: undefined,
    placeholder: '',
    defaultValue: 'TX',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    maxLength: 15,
    placeholder: '',
    defaultValue: '78731',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    name: 'countryCode',
    label: 'Country',
    type: 'auto',
    maxLength: 35,
    placeholder: '',
    defaultValue: 'US',
    required: false,
    disabled: false,
    icon: undefined,
    hidden: false,
  },
  {
    type: 'new',
  },
  {
    name: 'saveParty',
    label: 'Save Party',
    type: 'toggle',
    maxLength: undefined,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    hidden: true,
  },
  {
    name: 'myPartyId',
    label: 'My Party ID',
    type: 'text',
    maxLength: 35,
    placeholder: '',
    defaultValue: false,
    required: false,
    disabled: false,
    icon: undefined,
    hidden: true,
  },
];

const partyFields = {};
const optionsMap = {};
Object.entries(parties).forEach(([partyCode]) => {
  partyFields[partyCode] = []; // set up type to be array
  party.forEach((field) => {
    if(field.hidden)
      return;
    if (field.type !== 'new') {
      const newField = {
        ...field,
        name: `${partyCode}-${field.name}`,
        required: ['ST', 'LG', 'CS'].includes(partyCode) ? false : field.required, // set required to optional for matched parties
      }
      partyFields[partyCode].push(newField);
    } else {
      partyFields[partyCode].push(field);
    }
  });
  optionsMap[`${partyCode}-partyLookup`] = partyLookup;
  optionsMap[`${partyCode}-stateProvince`] = usStates;
  optionsMap[`${partyCode}-countryCode`] = countries;
});

export {
  parties,
  partyFields,
  optionsMap
};